import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import {
  getLogIndexes,
  hasLog,
  normalizeLog,
} from 'ag-common-svc/lib/components/changes-history-grid/utils/normalize-log';
import { GuestEvents, GuestEventsMap } from '@ag-common-lib/lib/models/registration/guest.model';
import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';

@Component({
  selector: 'ag-shr-change-log-guest-events-detail',
  templateUrl: './change-log-guest-events.component.html',
  styleUrls: ['./change-log-guest-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogGuestEventsComponent {
  @Input()
  set log(delta: Delta) {
    this._log = delta
    this.logIndexes = getLogIndexes(Object.entries(delta)) ?? [];
    console.log(delta);
    console.log('logIndexes', this.logIndexes);
  }

  get log(): Delta {
    return this._log;
  }

  private _log: Delta;
  logIndexes: string[] = [];
  protected readonly guestEventsKeys = [GuestEvents.main, GuestEvents.chairmanExtension];
  protected readonly guestEventsLookup = [
    { [LookupKeys.value]: GuestEvents.main, [LookupKeys.description]: GuestEventsMap.get(GuestEvents.main) },
    {
      [LookupKeys.value]: GuestEvents.chairmanExtension,
      [LookupKeys.description]: GuestEventsMap.get(GuestEvents.chairmanExtension),
    },
  ];
  protected readonly hasLog = hasLog;
  protected readonly normalizeLog = normalizeLog;
}
